import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  IProductionChainStep,
  productionUiDisplayStateSelector,
} from "@ryde/shared";

import { GroupTitleTemplate } from "../../../dynamic-forms";
import {
  GeneralInfoBlock,
  GeneralInfoTextBlock,
  GeneralInfoTitleBlock,
  ProductionChainStepContent,
  ProductionPreviewProgress,
  ProductionPreviewResult,
  ProductionPreviewWrapperStyled,
} from "../components";

interface IProductionPreviewChainDetailsProps {
  chain: IProductionChainStep;
  isStarted: boolean;
  isAborting?: boolean;
  isOtherProductionInProgress: boolean;
  handleProductionAbort: () => void;
  handlePreviousProductionClick: () => void;
}

export const ProductionPreviewChainDetails: FC<
  IProductionPreviewChainDetailsProps
> = ({
  chain,
  isStarted,
  isAborting = false,
  isOtherProductionInProgress,
  handleProductionAbort,
  handlePreviousProductionClick,
}) => {
  const { t } = useTranslation();
  const { productionId } = useRecoilValue(productionUiDisplayStateSelector);

  return (
    <ProductionPreviewWrapperStyled>
      <ProductionPreviewProgress
        isStarted={isStarted}
        isAborting={isAborting}
        isOtherProductionInProgress={isOtherProductionInProgress}
        handleProductionAbort={handleProductionAbort}
        handlePreviousProductionClick={handlePreviousProductionClick}
      />

      <ProductionPreviewResult
        isStarted={isStarted}
        action={chain.data.action}
      />

      <GroupTitleTemplate
        name="generalInfo"
        formLabel={t("rideProduction.generalInfo")}
      />

      {Boolean(productionId) && (
        <GeneralInfoBlock>
          <GeneralInfoTitleBlock>
            {t("ride.PRODUCTION_ID")}
          </GeneralInfoTitleBlock>
          <GeneralInfoTextBlock>{productionId}</GeneralInfoTextBlock>
        </GeneralInfoBlock>
      )}

      <ProductionChainStepContent chainStep={chain} />
    </ProductionPreviewWrapperStyled>
  );
};
